import { render, staticRenderFns } from "./BrandRecentlyViewed.vue?vue&type=template&id=1c2242e4&"
import script from "./BrandRecentlyViewed.vue?vue&type=script&lang=ts&"
export * from "./BrandRecentlyViewed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports